<article>
  <opac-avatar [style.--background-color]="userPicture()?.color" [picture]="userPicture()?.pictureUrl">
    {{ userPicture()?.content ?? '' | avatarText }}
  </opac-avatar>

  <form [formGroup]="form" [id]="formId()" (submit)="reply($event)">
    <opac-textarea #textarea [id]="textareaId" [counter]="true" formControlName="comment" [invalid]="commentControl | invalidControl" [maxLength]="maxLength()">
      {{ 'info.comments.edit.label' | translate }}
      <span *ngIf="commentControl | invalidControl" slot="error">
        <span *ngIf="commentControl.errors.maxlength">{{ 'textarea.charCountExceeded' | translate }}</span>
        <span *ngIf="commentControl.errors.requiredWithUsername">{{ 'info.comments.edit.errorEmpty' | translate }}</span>
      </span>
    </opac-textarea>

    <div class="actions">
      <opac-button actionType="submit" [form]="formId()">{{ submitLabel | translate }}</opac-button>
      <opac-button type="secondary" (click)="cancel()">{{ 'info.comments.actions.cancel' | translate }}</opac-button>
    </div>
  </form>
</article>
